import {BlobServiceClient} from '@azure/storage-blob'

/* eslint-disable no-console */
export default async function usePim(filename, config) {
  const containerName = config.CATEGORY_JSON_CONTAINER_NAME || 'pim2enext'
  const connectionString = config.CATEGORY_JSON_CONNECTION_STRING
  const filePath = `${filename}` // The path to the file within the container
  try {
    const blobServiceClient = BlobServiceClient.fromConnectionString(connectionString)

    // Get a reference to a container
    const containerClient = blobServiceClient.getContainerClient(containerName)

    // Get a block blob client
    const blobClient = containerClient.getBlobClient(filePath)
    const downloadBlockBlobResponse = await blobClient.download(0)

    // Convert stream to text
    const downloaded = await streamToText(downloadBlockBlobResponse.readableStreamBody)
    return JSON.parse(downloaded)
  } catch (err) {
    console.error(`Failed to load PIM data: ${err.message}`)
    throw err
  }
}

// Helper function to convert a readable stream to text
async function streamToText(readable) {
  readable = await readable
  const chunks = []
  for await (const chunk of readable) {
    chunks.push(Buffer.from(chunk))
  }
  return Buffer.concat(chunks).toString('utf-8')
}
